import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import InputValueProps from '../../../../../prop-types/input-value-props';
import sharedStyles from '../../../../../../automation-rules/style.module.less';
import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import TextAreaWithInsertParameter from '../../../../../../../../components/text-area-with-insert-parameter';
import EmailParameterInsertOptions from './email-parameter-insert-options';
import { useSelector } from 'react-redux';
import Global from '../../../../../../../../store/global-selectors';
import { INT_PARAMETER, PARAMETER } from '../../../../../constants/parameter-name-for-update';
import classnames from 'classnames';
import messages from './messages';
import style from './style.module.less';

const SendAnEmail = ({ inputValueProps, onChange, label }) => {
  const { [PARAMETER]: parameter, [INT_PARAMETER]: intParameter } = inputValueProps;
  const deliveryTemplates = useSelector(Global.selectSellerDeliveryTemplates);
  const shipmentTemplates = useSelector(Global.selectSellerShipmentTemplates);
  const memoizedTemplates = useMemo(() => {
    return [
      ...deliveryTemplates.map((dt) => ({
        ...dt,
        [INT_PARAMETER]: Number.parseInt(dt.emailTemplateId, 10),
      })),
      ...shipmentTemplates.map((dt) => ({
        ...dt,
        [INT_PARAMETER]: Number.parseInt(dt.emailTemplateId, 10),
      })),
    ];
  }, [deliveryTemplates, shipmentTemplates]);
  const setActionValue = useCallback(
    (content) => {
      onChange({
        [PARAMETER]: content,
        [INT_PARAMETER]: intParameter,
      });
    },
    [onChange, intParameter],
  );

  const onSetTemplate = useCallback(
    (emailTemplateId) => {
      onChange({
        [PARAMETER]: parameter,
        [INT_PARAMETER]: emailTemplateId,
      });
    },
    [onChange, parameter],
  );

  const selectedTemplate = memoizedTemplates.find((tmp) => tmp.emailTemplateId === intParameter?.toString());

  return (
    <div className={style['create-alert']}>
      <div className={style['multi-control-row']}>
        <div>{label}</div>
        <TextAreaWithInsertParameter onChange={setActionValue} parameterOptions={EmailParameterInsertOptions} value={parameter} />
      </div>
      <div className={classnames(style.stacked, style['multi-control-row'])}>
        <div>
          <FormattedMessage {...messages.sendEmailTemplate} />
        </div>
        <div>
          <DropdownMenu className={sharedStyles['dropdown-menu']} dropdownMenuShouldHaveWidthOfButton>
            <DropdownMenuToggler className={sharedStyles['dropdown-toggler']}>
              {selectedTemplate && selectedTemplate.name}
              {!selectedTemplate && <FormattedMessage {...messages.noOptionSelectedMessage} />}
            </DropdownMenuToggler>
            {memoizedTemplates.map(({ emailTemplateId, name }) => {
              return (
                <DropdownMenuItem
                  key={emailTemplateId}
                  className={sharedStyles['dropdown-item']}
                  onClick={() => onSetTemplate(emailTemplateId)} // TODO: remove anon when dropdown supports typing for a further nested element
                  theme='unstyled'
                >
                  {name}
                </DropdownMenuItem>
              );
            })}
          </DropdownMenu>
        </div>
      </div>
    </div>
  );
};

SendAnEmail.propTypes = {
  inputValueProps: InputValueProps.isRequired,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.node.isRequired,
};

export default SendAnEmail;
